import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useMemo } from "react";
import { TAccount } from "../../../../api/v1_0";
import { useStore } from "../../../../store";
import { Goal } from "./_dependencies";
import { IGoalsProps } from "./types";

export const Goals: FunctionComponent<IGoalsProps> = observer(
  (props: IGoalsProps): ReactElement<IGoalsProps> => {
    const { addAccount, closeAccount, openAccount, ...restProps } = props;
    const store = useStore();
    const goals: Array<TAccount> = useMemo(
      () =>
        [...store.wallet.goals.values()].map((expenseCategory) => ({
          ...expenseCategory,
          balance:
            store.operations.accounts.get(expenseCategory.uuid)?.amount || 0,
        })),
      [store.wallet.accounts, store.operations.accounts]
    );

    return (
      <div className="contentBox marginBottom whiteBlockBg">
        <div className="contentBoxHeader">
          <h3>Цели</h3>
          {false && (
            <a href="#" className="link" onClick={addAccount}>
              Добавить
            </a>
          )}
        </div>
        <div className="row">
          {goals.map((goal) => (
            <Goal key={goal.uuid} goal={goal} onPress={openAccount} />
          ))}
        </div>
      </div>
    );
  }
);
